import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../../Tabels/Tabels.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import ModalSave from "../../../common/ModelSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../../../utils/context";
import JoditEditor from "jodit-react";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, getDimension, Select2Data } = useContext(Context);
  const [bank, setBank] = useState([]);
  const [profcymaGuarantee, setProfcymaGuarantee] = useState([]);
  const [insuranceType, setInsuranceType] = useState([]);
  const [insuranceAdvantage, setInsuranceAdvantage] = useState([]);
  const [insuranceDisAdvantage, setInsuranceDisadvantage] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const imageFile = watch("image");
  const imageBrochure = watch("brochure");
  const imageFile1 = watch("icon");
  console.log(errors);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data?.name);
      DataToSend.append("bank_id", data?.bank_id.value);
      DataToSend.append("refund_premium", data?.refund_premium);
      DataToSend.append("about_plane", data?.about_plane);
      DataToSend.append("cover_till_age", data?.cover_till_age);
      DataToSend.append("what_not_cover", data?.what_not_cover);
      DataToSend.append("what_cover", data?.what_cover);
      DataToSend.append("claim_settled", data?.claim_settled);
      DataToSend.append("life_cover", data?.life_cover);
      DataToSend.append("income_status", data?.income_status);
      DataToSend.append("image", data?.image[0]);
      DataToSend.append("brochure", data?.brochure[0]);
      DataToSend.append("alt_tag", data?.alt_tag || "");

      const profcymaGuaranteeIds = data.profcyma_guarantee_id.map((item) =>
        Number(item.value)
      );

      DataToSend.append(
        "profcyma_guarantee_id",
        JSON.stringify(profcymaGuaranteeIds)
      );

      const insurance_advantage_id = data.insurance_advantage_id.map((item) =>
        Number(item.value)
      );

      DataToSend.append(
        "insurance_advantage_id",
        JSON.stringify(insurance_advantage_id)
      );
      const insurance_disadvantage_id = data.insurance_disadvantage_id.map((item) =>
        Number(item.value)
      );

      DataToSend.append(
        "insurance_disadvantage_id",
        JSON.stringify(insurance_disadvantage_id)
      );

      const add_on = [];
      data.add_on.forEach((val) => {
        const addOn = {
          name: val.name,
          description: val.description,
          type: val.type?.value,
        };

        if (val?.rate) {
          addOn.rate = val.rate;
        }

        add_on.push(addOn);
      });

      const payout_option = [];
      data.payout_option.forEach((val) => {
        const addOn = {
          f_insurance_type_id: val.f_insurance_type_id.value,
          online_amount: val.online_amount,
          offline_amount: val.offline_amount,
        };

        if (val?.rate) {
          addOn.rate = val.rate;
        }
        if (val?.cover_value) {
          addOn.cover_value = val.cover_value;
        }

        payout_option.push(addOn);
      });

      DataToSend.append("add_on", JSON.stringify(add_on));

      DataToSend.append("payout_option", JSON.stringify(payout_option));

      const response = await postData(`/masters/finance/insurance`, DataToSend);

      if (response?.success) {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllBank = async () => {
    const response = await getData("/all-bank");

    if (response?.success) {
      setBank(await Select2Data(response?.data, "bank_id"));
    }
  };

  const GetAllprofcymaguarantee = async () => {
    const response = await getData("/all-profcyma-guarantee");

    if (response?.success) {
      setProfcymaGuarantee(
        await Select2Data(response?.data, "profcyma_guarantee_id")
      );
    }
  };

  const GetAllInsuranceType = async () => {
    const response = await getData("/all-insurance-type");

    if (response?.success) {
      setInsuranceType(
        await Select2Data(response?.data, "f_insurance_type_id")
      );
    }
  };

  const GetAllInsuranceAdvantages = async () => {
    const response = await getData("/all-insurance-advantages");

    if (response?.success) {
      setInsuranceAdvantage(
        await Select2Data(response?.data, "insurance_advantage_id")
      );
    }
  };

  const GetAllInsuranceDisAdvantages = async () => {
    const response = await getData("/all-insurance-disadvantage");

    if (response?.success) {
      setInsuranceDisadvantage(
        await Select2Data(response?.data, "insurance_advantage_id")
      );
    }
  };

  useEffect(() => {
    GetAllBank();
    GetAllprofcymaguarantee();
    GetAllInsuranceType();
    GetAllInsuranceAdvantages();
    GetAllInsuranceDisAdvantages();
  }, []);
  const [addOnError, setAddOnError] = useState("");

  const type = [
    { value: "Paid", label: "Paid" }, // Fixed typo
    { value: "Free", label: "Free" },
  ];

  useEffect(() => {
    register("add_on", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setAddOnError(isValid ? "" : "At least one Add on is required");
        return isValid;
      },
    });
  }, [register]);
  const {
    fields: addOnFields,
    append: appendAddOn,
    remove: removeAddOn,
  } = useFieldArray({
    control,
    name: "add_on",
  });

  const {
    fields: payoutOptionFields,
    append: appendPayoutOption,
    remove: removePayoutOption,
  } = useFieldArray({
    control,
    name: "payout_option",
  });

  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e") {
      event.preventDefault(); // Prevent negative sign and scientific notation
    }
  };

  const [selectedTypes, setSelectedTypes] = useState({}); // Track selected types

  const handleTypeChange = (selectedOption, index) => {
    setSelectedTypes((prev) => ({
      ...prev,
      [index]: selectedOption?.value, // Store selected type per index
    }));
  };
  return (
    <>
      <Modal
        onHide={props.handleClose}
        {...props}
        size="lg"
        aria-labelledby="contained-modal-name-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-name-vcenter">
            Add Isurance
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            className="countryclass"
          >
            <Row>
              {/* name */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Bank</Form.Label>

                    <Controller
                      name="bank_id" // name of the field
                      {...register("bank_id", {
                        required: "Bank is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.bank_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={bank}
                        />
                      )}
                    />

                    {errors.bank_id && (
                      <span className="text-danger">
                        {errors.bank_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Profcyma Guarantee</Form.Label>

                    <Controller
                      name="profcyma_guarantee_id" // name of the field
                      {...register("profcyma_guarantee_id", {
                        required: "Profcyma Guarantee is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.profcyma_guarantee_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={profcymaGuarantee}
                        />
                      )}
                    />

                    {errors.profcyma_guarantee_id && (
                      <span className="text-danger">
                        {errors.profcyma_guarantee_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Insurance Advantage</Form.Label>

                    <Controller
                      name="insurance_advantage_id" // name of the field
                      {...register("insurance_advantage_id", {
                        required: "Insurance Advantage is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.insurance_advantage_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={insuranceAdvantage}
                        />
                      )}
                    />

                    {errors.insurance_advantage_id && (
                      <span className="text-danger">
                        {errors.insurance_advantage_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Insurance DisAdvantage</Form.Label>

                    <Controller
                      name="insurance_disadvantage_id" // name of the field
                      {...register("insurance_disadvantage_id", {
                        required: "Insurance DisAdvantage is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.insurance_disadvantage_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={insuranceDisAdvantage}
                        />
                      )}
                    />

                    {errors.insurance_disadvantage_id && (
                      <span className="text-danger">
                        {errors.insurance_disadvantage_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label> Title</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      type="text"
                      {...register("name", {
                        required: "Title is required",
                        // maxLength: {
                        //   value: 20,
                        //   message: "Title must be at most 20 characters long",
                        // },
                      })}
                      placeholder="Title"
                    />
                  </Form.Group>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Life Cover(in lac)</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.life_cover,
                      })}
                      type="text"
                      {...register("life_cover", {
                        required: "Life Cover is required",
                        pattern: {
                          value: /^[0-9]*$/, // Regex to allow only digits
                          message: "Only numbers are allowed",
                        },
                      })}
                      placeholder="Life Cover"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault(); // Prevent non-numeric input
                        }
                      }}
                    />
                  </Form.Group>
                  {errors.life_cover && (
                    <span className="text-danger">
                      {errors.life_cover.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Cover Till Age</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.cover_till_age,
                      })}
                      type="text"
                      {...register("cover_till_age", {
                        required: "Cover Till Age is required",
                        pattern: {
                          value: /^[0-9]*$/, // Regex to allow only digits
                          message: "Only numbers are allowed",
                        },
                      })}
                      placeholder="Cover Till Age"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault(); // Prevent non-numeric input
                        }
                      }}
                    />
                  </Form.Group>
                  {errors.cover_till_age && (
                    <span className="text-danger">
                      {errors.cover_till_age.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Claim Settled</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.claim_settled,
                      })}
                      type="text"
                      {...register("claim_settled", {
                        required: "Claim Settled is required",
                        pattern: {
                          value: /^[0-9]*$/, // Regex to allow only digits
                          message: "Only numbers are allowed",
                        },
                      })}
                      placeholder="Claim Settled"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault(); // Prevent non-numeric input
                        }
                      }}
                    />
                  </Form.Group>
                  {errors.claim_settled && (
                    <span className="text-danger">
                      {errors.claim_settled.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>What Cover</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.what_cover,
                      })}
                      type="text"
                      {...register("what_cover", {
                        required: "What Cover is required",
                        // maxLength: {
                        //   value: 20,
                        //   message: "Title must be at most 20 characters long",
                        // },
                      })}
                      placeholder="What Cover"
                    />
                  </Form.Group>
                  {errors.what_cover && (
                    <span className="text-danger">
                      {errors.what_cover.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>About Plane</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.about_plane,
                      })}
                      type="text"
                      {...register("about_plane", {
                        required: "About Plane is required",
                        // maxLength: {
                        //   value: 20,
                        //   message: "Title must be at most 20 characters long",
                        // },
                      })}
                      placeholder="About Plane"
                    />
                  </Form.Group>
                  {errors.about_plane && (
                    <span className="text-danger">
                      {errors.about_plane.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>What Not Cover</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.what_not_cover,
                      })}
                      type="text"
                      {...register("what_not_cover", {
                        required: "What Not Cover is required",
                        // maxLength: {
                        //   value: 20,
                        //   message: "Title must be at most 20 characters long",
                        // },
                      })}
                      placeholder="What Not Cover"
                    />
                  </Form.Group>
                  {errors.what_not_cover && (
                    <span className="text-danger">
                      {errors.what_not_cover.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label></Form.Label>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Income Status"
                      {...register("income_status", {
                        // required: "Please select at least one option",
                      })}

                      onChange={(e) => {
                        e.target.value = e.target.checked ? 1 : 0;
                      }}
                    />
                  </Form.Group>

                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label> Image</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      type="file"
                      {...register("image", {
                        // required: "Image is required",
                        // validate: async (value) => {
                        //   const fileTypes = ["jpg", "png", "jpeg"];
                        //   const fileType = value[0].name.split(".")[1];
                        //   if (!fileTypes.includes(fileType)) {
                        //     // return `please upload a valid file format. (${fileTypes})`;
                        //   }
                        //   const sizes = await getDimension(value[0]);
                        //   if (
                        //     sizes.width !== 1296 &&
                        //     sizes.height !== 465
                        //   ) {
                        //     // return "Image width and height must be 1296px and 465px";
                        //   }
                        //   const fileSize = Math.round(value[0].size / 1024);
                        //   if (fileSize > 500) {
                        //     // return "file size must be lower than 500kb";
                        //   }
                        // },
                      })}
                      accept=".jpg, .jpeg, .png"
                    />
                  </Form.Group>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Alt Tag</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.alt_tag,
                      })}
                      type="text"
                      {...register("alt_tag", {
                        // required: "Alt Tag is required",
                      })}
                      placeholder="Alt Tag"
                    />
                  </Form.Group>
                  {errors.alt_tag && (
                    <span className="text-danger">
                      {errors.alt_tag.message}
                    </span>
                  )}

                </div>
              </Col>
              <Col lg={6}>
                <div
                  className="main-form-section mt-3"
                  style={{ marginLeft: "50px" }}
                >
                  <Form.Label> Image Preview</Form.Label>

                  {imageFile && imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        src={URL.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "150px", height: "150px" }}
                      />
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Brochure</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.brochure,
                      })}
                      type="file"
                      {...register("brochure", {
                        // required: "Image is required",
                        // validate: async (value) => {
                        //   const fileTypes = ["jpg", "png", "jpeg"];
                        //   const fileType = value[0].name.split(".")[1];
                        //   if (!fileTypes.includes(fileType)) {
                        //     // return `please upload a valid file format. (${fileTypes})`;
                        //   }
                        //   const sizes = await getDimension(value[0]);
                        //   if (
                        //     sizes.width !== 1296 &&
                        //     sizes.height !== 465
                        //   ) {
                        //     // return "Image width and height must be 1296px and 465px";
                        //   }
                        //   const fileSize = Math.round(value[0].size / 1024);
                        //   if (fileSize > 500) {
                        //     // return "file size must be lower than 500kb";
                        //   }
                        // },
                      })}
                      accept=".pdf"
                    />
                  </Form.Group>
                  {errors.brochure && (
                    <span className="text-danger">
                      {errors.brochure.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div
                  className="main-form-section mt-3"
                  style={{ marginLeft: "50px" }}
                >
                  <Form.Label> PDF Preview</Form.Label>

                  {imageBrochure && imageBrochure?.length > 0 && (
                    <div className="image-preview-container">
                      <iframe
                        src={URL.createObjectURL(imageBrochure[0])}
                        title="PDF Preview"
                        width="100%"
                        height="200px"
                        style={{ border: "1px solid #ddd" }}
                      ></iframe>
                    </div>
                  )}
                </div>
              </Col>
              {/* Image Upload */}
              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    {" "}
                    {/* Align to left */}
                    {/* Description */}
                    <Col sm={12}>
                      <Form.Label className="text-center">
                        Refund Premium
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="refund_premium" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{ required: "Refund Premium is required" }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={field.value}
                              onChange={(newContent) =>
                                field.onChange(newContent)
                              }
                              onBlur={field.onBlur}
                              className={classNames("", {
                                "is-invalid": !!errors.refund_premium,
                              })}
                              placeholder="Refund Premium"
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.refund_premium && (
                        <span className="text-danger">
                          {errors.refund_premium.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
              <div className="main-form-section mt-5"></div>
              Add On
              {addOnError && <div className="text-danger">{addOnError}</div>}
              <hr />
              {addOnFields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Type</Form.Label>
                          <Controller
                            name={`add_on.${index}.type`} // name of the field
                            {...register(`add_on.${index}.type`, {
                              required: "Select Type",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.add_on?.[index]?.type
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={type}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption);
                                  handleTypeChange(selectedOption, index); // Track selection
                                }}
                              />
                            )}
                          />
                          {errors?.add_on?.[index]?.type && (
                            <span className="text-danger">
                              {errors?.add_on?.[index]?.type.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    {selectedTypes[index] === "Paid" && (
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Rate ₹</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="number"
                                name={`add_on.${index}.rate`}
                                placeholder="Rate"
                                min="0"
                                className={classNames("", {
                                  "is-invalid": errors?.add_on?.[index]?.rate,
                                })}
                                {...register(`add_on.${index}.rate`, {
                                  required: "Rate is required",
                                  validate: (value) =>
                                    value > 0 || "Rate must be greater than 0",
                                })}
                              />
                              {errors?.add_on?.[index]?.rate && (
                                <span className="text-danger">
                                  {errors?.add_on?.[index]?.rate.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                    )}

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Name</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`add_on.${index}.name`}
                              placeholder="Name"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid": errors?.add_on?.[index]?.name,
                              })}
                              {...register(`add_on.${index}.name`, {
                                required: "Name is required",
                              })}
                            />

                            {errors?.add_on?.[index]?.name && (
                              <span className="text-danger">
                                {errors?.add_on?.[index]?.name.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>description</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`add_on.${index}.description`}
                              placeholder="Description"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid":
                                  errors?.add_on?.[index]?.description,
                              })}
                              {...register(`add_on.${index}.description`, {
                                required: "Description is required",
                              })}
                            />

                            {errors?.add_on?.[index]?.description && (
                              <span className="text-danger">
                                {errors?.add_on?.[index]?.description.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col lg={3}>
                      <button
                        className="btn btn-danger mt-3"
                        type="button"
                        onClick={() => removeAddOn(index)}
                      >
                        Remove Add On
                      </button>
                    </Col>
                  </Row>
                </div>
              ))}
              <div className="main-form-section mt-3"></div>
              <hr />
              <div className="text-center"></div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={() => appendAddOn({})}
                >
                  + Add Add on
                </button>
              </div>
              <div className="main-form-section mt-5"></div>
              Payout Option
              {addOnError && <div className="text-danger">{addOnError}</div>}
              <hr />
              {payoutOptionFields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Insurance Type</Form.Label>
                          <Controller
                            name={`payout_option.${index}.f_insurance_type_id`} // name of the field
                            {...register(
                              `payout_option.${index}.f_insurance_type_id`,
                              {
                                required: "Select Type",
                              }
                            )}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.add_on?.[index]
                                      ?.f_insurance_type_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={insuranceType}
                              />
                            )}
                          />
                          {errors?.payout_option?.[index]
                            ?.f_insurance_type_id && (
                              <span className="text-danger">
                                {
                                  errors?.payout_option?.[index]
                                    ?.f_insurance_type_id.message
                                }
                              </span>
                            )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Online Amount ₹</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="number"
                              name={`payout_option.${index}.online_amount`}
                              placeholder="Online Amount"
                              min="0"
                              className={classNames("", {
                                "is-invalid":
                                  errors?.payout_option?.[index]?.online_amount,
                              })}
                              {...register(
                                `payout_option.${index}.online_amount`,
                                {
                                  required: "Online Amount is required",
                                  validate: (value) =>
                                    value > 0 ||
                                    "Online Amount must be greater than 0",
                                }
                              )}
                            />
                            {errors?.payout_option?.[index]?.online_amount && (
                              <span className="text-danger">
                                {
                                  errors?.payout_option?.[index]?.online_amount
                                    .message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Offline Amount ₹</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="number"
                              name={`payout_option.${index}.offline_amount`}
                              placeholder="Offline Amount"
                              min="0"
                              className={classNames("", {
                                "is-invalid":
                                  errors?.payout_option?.[index]
                                    ?.offline_amount,
                              })}
                              {...register(
                                `payout_option.${index}.offline_amount`,
                                {
                                  required: "Offline Amount is required",
                                  validate: (value) =>
                                    value > 0 ||
                                    "Offline Amount must be greater than 0",
                                }
                              )}
                            />
                            {errors?.payout_option?.[index]?.offline_amount && (
                              <span className="text-danger">
                                {
                                  errors?.payout_option?.[index]?.offline_amount
                                    .message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col lg={3}>
                      <button
                        className="btn btn-danger mt-3"
                        type="button"
                        onClick={() => removePayoutOption(index)}
                      >
                        Remove Payout Option
                      </button>
                    </Col>
                  </Row>
                </div>
              ))}
              <div className="main-form-section mt-3"></div>
              <hr />
              <div className="text-center"></div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={() => appendPayoutOption({})}
                >
                  + Add Payout Option
                </button>
              </div>
            </Row>

            {/* Buttons */}
            <Row className="justify-content-center mt-5 pb-3">
              <Col sm={6} className="d-flex justify-content-center">
                <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                <SaveButton
                  name={"Save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
